import { getAuthHeaders } from '../../../actions/authActions';
import tempMeeApi from '../../../apis/tempMee';
import { INTERNAL_USERS_ENDPOINT } from './GetInternalUsers';

/**
 * Composed from the list endpoint rather than restated: the two routes are the
 * same auth-service group, and a path that drifts here fails as a 404, which
 * this caller cannot tell from "not GoTu staff".
 */
export const INTERNAL_USER_ME_ENDPOINT = `${INTERNAL_USERS_ENDPOINT}/me`;

/**
 * The calling admin's own GoTu Admin row: `GET /admin/internal-users/me`.
 *
 * Role is deliberately absent from the JWT (GOTU-6359): auth-service derives
 * *claims* from `internal_role` and puts those in the token, so the slug itself
 * has to be fetched. That is also why nothing here reads the access token's
 * payload — the role is not in it, and authorization is the claims' job either
 * way. This value is for display and audit only.
 *
 * Takes no arguments on purpose. The route resolves the caller from the token
 * and ignores any id supplied, so accepting one would imply a lookup this
 * endpoint does not perform.
 *
 * Bearer is added by hand, as the other auth-service callers do, rather than
 * via `getAuthServiceHeaders`.
 *
 * Rejects on 404, which auth-service returns for an admin holding no
 * `internal_user` row. That is a real answer about provisioning rather than an
 * error to swallow, so it reaches the caller instead of becoming an empty row.
 *
 * @returns {Promise<import('../types/User.api').IInternalUserApiModel>}
 */
export const getInternalUserMe = async () => {
  const { Authorization: accessToken } = await getAuthHeaders();

  const response = await tempMeeApi.get(INTERNAL_USER_ME_ENDPOINT, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });

  return response.data;
};
